import { PrimaryButton } from "@fluentui/react";
import * as Adaptive from "adaptivecards";
import { TypedCardElementPeer, PropertySheet, PropertySheetCategory, StringPropertyEditor } from "adaptivecards-designer";
import React from "react";
import { createRoot } from 'react-dom/client';
import { removeOtherPropertyConfigurations } from "./Utils/CustomElementUtils";

const displayLabelProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_0, "displayLabel", true);

export class SubmitRequest extends Adaptive.TextInput {
    static readonly JsonTypeName = "Submit Request";
    static readonly ElementId = "Ticket.SubmitRequest";
    static readonly defaultLabel = "Submit Request";
    static readonly displayLabelProperty = displayLabelProperty;
    static hideField: boolean;

    //#region Schema

    @Adaptive.property(displayLabelProperty)
    get displayLabel(): string | undefined {
        return this.getValue(SubmitRequest.displayLabelProperty);
    }

    set displayLabel(value: string | undefined) {
        this.setValue(SubmitRequest.displayLabelProperty, value);
        this.updateLayout();
    }

    //#endregion

    protected internalRender(): HTMLElement | undefined {
        this.id = SubmitRequest.ElementId;
        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = SubmitRequest.defaultLabel;

        if(SubmitRequest.hideField)
            this.isVisible = false;

        let renderedElement = document.createElement("div");
        renderedElement.setAttribute("style", "display: flex; width: max-content;");

        const domNode = document.createElement('div');
        const root = createRoot(domNode); 
        root.render(<PrimaryButton text={this.displayLabel} className="tikit-button" />);

        renderedElement.append(domNode);

        return renderedElement;
    }

    getJsonTypeName(): string {
        return SubmitRequest.JsonTypeName;
    }

    updateLayout(processChildren: boolean = true) {
        super.updateLayout(processChildren);
    }
}

export class SubmitRequestPeer extends TypedCardElementPeer<SubmitRequest> {
    static readonly displayLabelProperty = new StringPropertyEditor(Adaptive.Versions.v1_0, "displayLabel", "Label", false);

    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);

        propertySheet.add(
            defaultCategory,
            SubmitRequestPeer.displayLabelProperty);
    }
}